module.exports = __webpack_public_path__ + "img/kakao_ch.74f1801e.png";